import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody";

function CarryingElement({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionMicropiles.carryingElement")}</p>}
      inputValue={<span className="input">{value}</span>}
    />
  );
}

export default CarryingElement;
